import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { asList, getJson, money, statusClass } from '../helpers';

export default function PortfolioPage() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getJson('/api/projects')
      .then((data) => setProjects(asList(data)))
      .catch((err) => setError(err.response?.data?.error || 'Unable to load projects'))
      .finally(() => setLoading(false));
  }, []);

  const rows = useMemo(() => {
    const term = query.trim().toLowerCase();
    if (!term) return projects;
    return projects.filter((project) => {
      return (
        String(project.project_name || '').toLowerCase().includes(term) ||
        String(project.project_number || '').toLowerCase().includes(term)
      );
    });
  }, [projects, query]);

  return (
    <div className="pc-page">
      <div className="pc-crumb">Company / Portfolio</div>
      <div className="pc-title-row">
        <h1>Portfolio</h1>
      </div>
      <div className="pc-toolbar">
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Filter projects"
        />
      </div>
      <div className="pc-card">
        {loading ? (
          <div className="pc-empty">Loading projects…</div>
        ) : error ? (
          <div className="pc-empty">{error}</div>
        ) : rows.length === 0 ? (
          <div className="pc-empty">No projects match this filter.</div>
        ) : (
          <table className="pc-table">
            <thead>
              <tr>
                <th>Project</th>
                <th>Number</th>
                <th>Status</th>
                <th className="pc-right">Contract Value</th>
                <th className="pc-right">Current Budget</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((project) => (
                <tr
                  key={project.vuid}
                  className="pc-clickable"
                  onClick={() => navigate(`/procore/projects/${project.vuid}`)}
                >
                  <td>{project.project_name}</td>
                  <td className="pc-muted">{project.project_number}</td>
                  <td>
                    <span className={`pc-pill ${statusClass(project.status)}`}>
                      {project.status || 'active'}
                    </span>
                  </td>
                  <td className="pc-right">{money(project.total_contract_value || project.contract_value)}</td>
                  <td className="pc-right">{money(project.current_budget || project.revised_budget)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
